import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MONCLER: Protection as design
// Padded grids, thermal lines, topographic geometry
export function VasarelyMonclerMode({ brand }: ModeRendererProps) {
  const monclerRed = "#C8102E";
  const monclerBlue = "#003F87";

  return (
    <g>
      {/* Alpine background */}
      <defs>
        <linearGradient id="moncler-alpine" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#E8F4F8" />
          <stop offset="100%" stopColor="#D0E8F0" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#moncler-alpine)" />

      <g transform="translate(397 540)">
        {/* Padded grid (quilted pattern) */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 52;
            const y = (j - 7.5) * 48;
            
            return (
              <g key={`${i}-${j}`}>
                <rect
                  x={x - 22}
                  y={y - 20}
                  width="44"
                  height="40"
                  fill={monclerBlue}
                  opacity="0.15"
                  rx="8"
                />
                <circle
                  cx={x}
                  cy={y}
                  r="4"
                  fill={monclerRed}
                  opacity="0.5"
                />
              </g>
            );
          })
        )}

        {/* Topographic geometry (mountain layers) */}
        {Array.from({ length: 14 }).map((_, i) => {
          const y = -220 + i * 32;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -280 + j * 14;
            const elevation = Math.sin(j * 0.15) * 30;
            return `${x},${y + elevation}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={monclerBlue}
              strokeWidth="2"
              opacity={0.3}
            />
          );
        })}

        {/* Thermal lines (insulation layers) */}
        {Array.from({ length: 18 }).map((_, i) => {
          const r = 40 + i * 13;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={monclerBlue}
              strokeWidth="1.5"
              opacity={0.3 - i * 0.014}
            />
          );
        })}

        {/* Protection nodes (shielding points) */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 190;
          
          return (
            <g key={angle}>
              {/* Padded node */}
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="24"
                fill={monclerBlue}
                opacity="0.3"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="12"
                fill={monclerRed}
                opacity="0.6"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="18"
                fill="none"
                stroke={monclerBlue}
                strokeWidth="2"
                opacity="0.5"
              />
            </g>
          );
        })}

        {/* Layered resilience */}
        {Array.from({ length: 8 }).map((_, i) => {
          const offset = i * 12;
          return (
            <rect
              key={i}
              x={-100 + offset}
              y={-80 + offset}
              width={200 - offset * 2}
              height={160 - offset * 2}
              fill="none"
              stroke={monclerBlue}
              strokeWidth="2"
              opacity={0.25 - i * 0.025}
              rx="16"
            />
          );
        })}

        {/* Central emblem (rooster-inspired geometry) */}
        <circle cx="0" cy="0" r="60" fill={monclerRed} opacity="0.3" />
        <circle cx="0" cy="0" r="60" fill="none" stroke={monclerBlue} strokeWidth="3" opacity="0.7" />
        
        {/* Tricolor stripes */}
        <rect x="-50" y="-8" width="100" height="4" fill={monclerBlue} opacity="0.7" />
        <rect x="-50" y="-2" width="100" height="4" fill={brand.white} opacity="0.9" />
        <rect x="-50" y="4" width="100" height="4" fill={monclerRed} opacity="0.7" />
      </g>

      {/* Moncler text */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="sans-serif" fontWeight="700" fontSize="11" fill={monclerBlue} opacity="0.8">
        PROTECTION PAR LE DESIGN
      </text>
    </g>
  );
}
